import { render, staticRenderFns } from "./TextMediaSlider.vue?vue&type=template&id=0876eb78&scoped=true"
import script from "./TextMediaSlider.vue?vue&type=script&lang=js"
export * from "./TextMediaSlider.vue?vue&type=script&lang=js"
import style0 from "./TextMediaSlider.vue?vue&type=style&index=0&id=0876eb78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876eb78",
  null
  
)

export default component.exports